import { render } from "./CreateAccountForm.vue?vue&type=template&id=5614bdf1"
import script from "./CreateAccountForm.vue?vue&type=script&lang=js"
export * from "./CreateAccountForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__